import Icon from 'veui/components/Icon'
import { IconOutdent } from 'dls-icons-vue'

Icon.register('outdent', IconOutdent)
